import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

export const DATE_FORMATTER = 'DD MMM YYYY';
export const SERVER_DOB_FORMATTER = 'DD/MM/YYYY';
export const TIMEZONE_JAKARTA = 'Asia/Jakarta';

type FormatOption = {
  formatter?: string;
  timezone?: string;
};

export const initDayjs = () => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(customParseFormat);
};

export const formatDate = (
  date: string | number | Dayjs,
  formatOption: FormatOption = {},
) => {
  if (!date) return '-';
  const { formatter = DATE_FORMATTER, timezone } = formatOption;
  return timezone
    ? dayjs(date).tz(timezone).format(formatter)
    : dayjs(date).local().format(formatter);
};

export const localUnix2IdUnix = (localUnix?: number) => {
  if (!localUnix) return undefined;
  const mom = dayjs(localUnix);
  const idMom = mom.clone().tz('Asia/Jakarta', true);
  return idMom.valueOf();
};
